import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/**
 * Button that needs to held down to confirm an action.
 */
@Component({
    selector: 'app-delayed-button',
    templateUrl: './delayed-button.component.html',
    styleUrls: ['./delayed-button.component.scss'],
    standalone: false,
})
export class DelayedButtonComponent implements OnInit {
    /**
     * Color for the active part of the button
     */
    @Input() activeColor = '#EB5153';
    /**
     * Color for the inactive part of the button
     */
    @Input() inactiveColor = '#DCDCDC';
    /**
     * Icon to show on the button
     */
    @Input() icon = 'delete';
    /**
     * Color for the icon
     */
    @Input() iconColor = '#0000003D';

    /**
     * Emitted when the button was fully pressed
     */
    @Output() finished = new EventEmitter<void>();

    percent = 0;
    private interval?: any;

    ngOnInit() {
        this.percent = 0;
    }

    get style(): { [key: string]: string } {
        return {
            background: `linear-gradient(to top, ${this.activeColor} ${this.percent}%, transparent 0%)`,
        };
    }

    start(): void {
        this.percent = 0;
        this.interval = setInterval(() => {
            this.percent += 4;
            if (this.percent === 100) {
                clearInterval(this.interval);
            }
        }, 10);
    }

    onFinished(): void {
        if (this.percent === 100) {
            this.finished.emit();
        }
        this.stop();
    }

    stop(): void {
        this.percent = 0;
        clearInterval(this.interval);
    }
}
